import api from './api'

export const authService = {
  login: (username, password) => {
    return api.post('/auth/login', { username, password })
  },

  logout: () => {
    return api.post('/auth/logout')
  },

  getProfile: () => {
    return api.get('/auth/profile')
  },

  changePassword: (oldPassword, newPassword, confirmPassword) => {
    return api.put('/auth/change-password', {
      oldPassword,
      newPassword,
      confirmPassword
    })
  }
}
